<template>
  <section class="vbox">
    <section class="scrollable padder">
      <section class="row m-b-md brud-theme">
        <div class="col-sm-6 text-black">
          <ol class="breadcrumb text-left">
            <li>
              <a href="#"><i class="fa fa-dashboard"></i> Home</a>
            </li>
            <li class="active">List of Payment</li>
          </ol>
        </div>
        <div class="col-sm-6 text-right text-left m-t-sm">
          <small> </small>
        </div>
      </section>

      <section class="panel panel-default">
        <header class="panel-heading">
          <div class="row">
            <div class="col-sm-12">
              <a
                v-on:click="showForm(0)"
                class="btn btn-success pull-right"
              >
                <i class="fa fa-plus"> </i> New Payment
              </a>
              <h4>
                <i class="fa fa-list-ul"></i>
                Search Payment
              </h4>
            </div>
          </div>
        </header>
        <div class="modal-body">
          <form @submit.prevent="getList()" method="post">
            <div class="row">
              <div class="col-sm-4">
                <div class="form-group">
                  <label> Payment Head</label>
                  <select
                    class="form-control "
                    v-model="category_id"
                    id="category_id"
                    name="category_id"
                    style="width: 100%;"
                  >
                    <option value="">Choose Head</option>
                   <option
                    v-for="category in categoryList"
                    :key="category.category_id"
                    v-bind:value="category.category_id"
                    >{{ category.category_name }}</option
                  >
                  </select>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-4">
                <div class="form-group" style="padding-top: 25px;">
                  <button type="submit" class="btn btn-success">
                    &nbsp;&nbsp;&nbsp; Search &nbsp;&nbsp;&nbsp;
                  </button>
                  <!-- <a href="" class="btn btn-danger"
                    >&nbsp;&nbsp;&nbsp;&nbsp; Reset &nbsp;&nbsp;&nbsp;&nbsp;</a
                  > -->
                </div>
              </div>
            </div>
          </form>
        </div>
      </section>
      <panel-modal
        v-if="showFormModal"
        class-list="col-md-6"
        @close="showFormModal = false"
      >
        <template #header>
          <h4>
            <i class="fa fa-list-ul"></i>
            Add / Edit Payment
          </h4>
        </template>
        <template #body>
          <AddPayment
            :paymentId="itemId"
            v-on:list-items="getList()"
            v-on:hide-form="showFormModal = false"
          />
        </template>
      </panel-modal>
      <section class="content">
        <div class="row">
          <div class="col-md-12">
            <div class="box">
              <div class="panel panel-default">
                <div class="panel-heading">
                  <i class="fa fa-list-ul"></i>
                  PAYMENT LIST
                </div>
                <div style="overflow-x:auto;" class="panel-body">
                  <table
                    class="table table-striped table-bordered table-hover"
                  >
                    <thead>
                      <tr>
                        <th width="5%">#</th>
                        <th width="10%">Payment Date</th>
                        <th width="10%">Payment Category</th>
                        <th width="10%">Description</th>
                        <th width="10%">Reference Number</th>
                        <th width="10%">Amount</th>
                        <th width="10%">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="item in itemList"
                        :key="item.payment_id"
                      >
                        <td id="sino"></td>
                        <td>
                          {{ dateFormat(item.payment_date) }}</td>
                        <td>
                          {{ item.category_name }}</td>
                        <td>
                          {{ item.description }}</td>
                        <td>
                          {{ item.reference_no }}</td>
                        <td>
                          {{ item.amount }}</td>
                        <td>
                          <a
                            v-on:click="showForm(item.payment_id)"
                            class="btn label-warning btn-xs"
                            style="float: left;display: block; width: 100%;"
                            ><i class="fa fa-edit"></i> Edit</a
                          >
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <!-- Show pagination links -->
                  <p class="total">Total: {{totalPayment}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </section>
  </section>
</template>

<script>

import api from "../api";
import AddPayment from "../components/AddPayment.vue";
import PanelModal from "../components/PanelModal.vue";

export default {
  name: "Payment",

  components: {
    AddPayment,
    PanelModal,
  },
  data() {
    return {
      showFormModal: false,
      showCartModal: false,
      itemList: [],
      categoryList: [],
      itemId: "",
      category_id: '',
      StatusActive: true
    };
  },
  computed: {
    totalPayment: function() {
      return this.itemList.reduce( function(total, amount){
        return total + parseFloat(amount.amount);
      }, 0)
    }
  },
  methods: {
    getCategories: function() {
      const list = {
        filter: {
        },
      };
      api
        .request("post", "GeneralApis/get_payment_category", list)
        .then((response) => {
          var data = response.data;
          console.log(data);
          if (data.errorcode) {
            this.categoryList = response.data.values;
          } else {
            this.categoryList = data.categoryList;
          }
        });
    },
    dateFormat: function(date) {
      var options = {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      };
      var formatdate = new Date(date);
      var dateformat = formatdate.toLocaleDateString("en-US", options);
      return dateformat;
    },
    getList: function() {
      const list = {
        filter: {
          category_id: this.category_id
        },
      };
      api
        .request("post", "GeneralApis/get_payment", list)
        .then((response) => {
          var data = response.data;
          console.log(data);
          if (data.errorcode) {
            this.itemList = [];
          } else {
            this.itemList = data.paymentList;
          }
        });
    },
    showForm: function(paymentid) {
      this.itemId = paymentid;
      this.showFormModal = true;
    }
  },
  mounted(){
    this.getCategories()
    this.getList()
  }
};
</script>
